module.exports = __webpack_public_path__ + "static/img/13.5139e3dc.png";